import React from 'react';

interface ArrowIconProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const ArrowIcon: React.FC<ArrowIconProps> = ({ 
  className, 
  width = 16, 
  height = 16 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      className={className} 
      width={width} 
      height={height} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    >
      <path d="M5 12h14M12 5l7 7-7 7"/>
    </svg>
  );
};

export default ArrowIcon; 